import React, { memo } from "react";
import { barGraph } from "../CommonForm/CommonFormInterface";

const BarGraph = ({
  field,
  extractedLabel,
  extractedValue,
  barHeight,
}: {
  field: barGraph;
  barHeight: (obj: any) => string;
  extractedLabel: (obj: any) => string;
  extractedValue: (obj: any) => string;
}) => {
  return (
    <div className="bar-graph">
      <div className="bar-parent-container" style={field?.style ?? {}}>
        {field?.columns?.map((column: any, columnIdx: number) => {
          return (
            <div
              key={extractedLabel(column) + columnIdx}
              className="bar-container"
            >
              <div className="bar" style={{ ...(column?.style ?? {}) }}>
                <label className="">₹{extractedValue(column)}</label>
                <div
                  className="bar-progress"
                  style={{
                    height: barHeight(column),
                    ...(column?.barStyle ?? {}),
                  }}
                />
              </div>
              <label className="bar-graph-main-label">
                {column?.prefix ?? ""}
                <span style={{ ...(column?.labelStyle ?? {}) }}>
                  {extractedLabel(column)}
                </span>
                {column?.postfix ?? ""}
              </label>
            </div>
          );
        })}
      </div>
      <div className={"horizontal_bottom_bar"} />
    </div>
  );
};

export default memo(BarGraph);
